import { Heading } from '@lmig/lmds-react-typography';
import { FloatingHeader } from '@lmig/lmds-react-floating-header';
import './LoginError.scss';
import { Link } from '@lmig/lmds-react-link';
import { IconContact, IconLockOpen, IconWarning } from '@lmig/lmds-react-icons';
import { useEffect } from 'react';
import { getPLDomain, getPLForgotPassword } from 'Foundation/Configurations/GlobalConfiguration';
import UnauthenticatedPageFooter from 'Feature/Chrome/Footer/UnauthenticatedPageFooter';

export default function PLLoginError() {
  useEffect(() => {
    document.title = 'Login Error';
  }, []);

  return (
    <div className="login-error-page">
      <FloatingHeader
        brand="liberty"
        isFullWidth={true}
        isFullBackground={false}
        brandLinkProps={{ href: `${getPLDomain()}/start` }}
      />
      <div className="login-error-page-content">
        <div className="login-error-message">
          <IconWarning size="64" />
          <Heading type="h4">We're sorry, it looks like there was an error logging in.</Heading>
        </div>
        <div className="login-error-help">
          <div className="login-error-tiles">
            <div className="login-error-tile">
              <IconLockOpen />
              <p>
                Do you need to reset your password? Reset your password <Link href={getPLForgotPassword()}>here</Link>.
              </p>
            </div>
            <div className="login-error-tile">
              <IconContact />
              <p>
                If this issue persists, please contact Agency Support by phone at{' '}
                <Link href="tel:877-566-6001">877-566-6001</Link>.
              </p>
            </div>
          </div>
          <p className="login-error-subtext">
            For general troubleshooting tips, please visit the{' '}
            <Link href="/PL/browser-troubleshooting">browser troubleshooting guide</Link>.
          </p>
        </div>
      </div>
      <UnauthenticatedPageFooter />
    </div>
  );
}
